import {InjectionToken, TemplateRef, Type} from '@angular/core';
import {Observable, Subject} from 'rxjs';

export const DIALOG_DATA = new InjectionToken<any>('DIALOG_DATA');

export const DIALOG_REF = new InjectionToken<DialogRef<any>>('DIALOG_REF');

export type DialogPosition =
  | 'center'
  | 'top'
  | 'bottom'
  | 'left'
  | 'right'
  | 'topleft'
  | 'topright'
  | 'bottomleft'
  | 'bottomright';

export type DialogHeaderTemplate = TemplateRef<DialogTemplateCtx> | Type<unknown>;
export type DialogFooterTemplate = TemplateRef<DialogTemplateCtx> | Type<unknown>;

export interface DialogTemplateCtx<TResult = unknown> {
  $implicit: DialogRef<TResult>;
}

export interface DynamicDialogConfig<TData = unknown, TResult = unknown> {
  data?: TData;
  headerTemplate?: DialogHeaderTemplate;
  footerTemplate?: DialogFooterTemplate;
  minWidth?: string;
  minHeight?: string;

  header?: string;
  footer?: string;
  ariaLabelledBy?: string;
  closeAriaLabel?: string;

  width?: string;
  height?: string;
  style?: Record<string, string>;
  contentStyle?: Record<string, string>;
  styleClass?: string;
  maskStyleClass?: string;
  breakpoints?: Record<string, string>;
  transitionOptions?: string;

  modal?: boolean;
  closable?: boolean;
  closeOnEscape?: boolean;
  dismissableMask?: boolean;
  draggable?: boolean;
  resizable?: boolean;
  maximizable?: boolean;
  maximizeIcon?: string;
  minimizeIcon?: string;
  keepInViewport?: boolean;
  minX?: number;
  minY?: number;

  focusOnShow?: boolean;
  focusTrap?: boolean;
  autoZIndex?: boolean;
  baseZIndex?: number;
  position?: DialogPosition;
  appendTo?: 'body' | HTMLElement;

  duplicate?: boolean;
  rtl?: boolean;
  unstyled?: boolean;
}

export class DialogRef<TResult = unknown> {
  private readonly _afterClosed$ = new Subject<TResult | undefined>();

  readonly afterClosed$: Observable<TResult | undefined> =
    this._afterClosed$.asObservable();

  _resolve(result?: TResult): void {
    if (!this._afterClosed$.closed) {
      this._afterClosed$.next(result);
      this._afterClosed$.complete();
    }
  }

  close(result?: TResult): void {
    this._closeCallback?.(result);
  }

  _closeCallback?: (result?: unknown) => void;
}
